import styled from 'styled-components';
export var CardText = styled.div.withConfig({
  displayName: "CardText",
  componentId: "sc-58ievt-0"
})(["", ";word-wrap:break-word;"], function (_ref) {
  var centered = _ref.centered;
  return centered ? 'align-self: center;' : null;
});